define('views/content/reseller_settings',['require','backbone','views/components/reseller_settings/company_settings','views/components/reseller_settings/profile_settings','views/components/reseller_settings/password_settings','models/reseller','models/reseller_manager','text!templates/content/reseller_settings.html'],function(require){

    var Backbone = require('backbone');

    var CompanySettingsView = require('views/components/reseller_settings/company_settings');
    var ProfileSettingsView = require('views/components/reseller_settings/profile_settings');
    var PasswordSettingsView = require('views/components/reseller_settings/password_settings');

    var ResellerModel = require('models/reseller');
    var ResellerManagerModel = require('models/reseller_manager');

    var temp = require("text!templates/content/reseller_settings.html");
    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'settings-page page',
        titleKey: 'settings',

        initialize: function () {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        regions: function() {
            return {
                CompanySettingsContainer: ".company-settings",
                ProfileSettingsContainer: ".profile-settings",
                PasswordSettingsContainer: ".password-settings"
            };
        },

        onRender: function () {
            var _this = this;

            var reseller = new ResellerModel({
                id: App.user.get('reseller')
            });

            reseller.fetch({
                success: function () {
                    _this.CompanySettingsContainer.show(new CompanySettingsView({
                        model: reseller
                    }));
                }
            });

            var manager = new ResellerManagerModel({
                id: App.user.get('id')
            });

            manager.fetch({
                success: function () {
                    _this.ProfileSettingsContainer.show(new ProfileSettingsView({
                        model: manager
                    }));
                }
            });

            _this.PasswordSettingsContainer.show(new PasswordSettingsView());
        }
    });
});
